import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Folder, NamedAdapter, Tag } from 'shell-models-lib';
import { Template, ITemplate } from 'app/model/template/template';
import { Owned } from 'app/model/base/named';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(Template)
})
export class TemplateAdapter extends NamedAdapter<Template, ITemplate> {
    protected _toResource(template: Template): ITemplate {
        const templateResource: ITemplate = {
            name: template.name,
            description: template.description,
            image: template.image,
            icons: template.icons,
            requires: template.requires,
            relatedTemplates: template.relatedTemplates,
            documentation: template.documentation,
            author: template.author,
            annotations: [],
            services: template.services,
            folder: this.context.adapterFor(Folder.MODEL).toResource(template.folder),
            categories: template.categories,
            scope: template.scope
        };
        const tagAdapter = this.context.adapterFor(Tag.MODEL);
        for (const tagNamed of template.tags) {
            // do not save it if user created an empty tag
            const tagResource = tagAdapter.toResource(tagNamed);
            if (tagResource) {
                templateResource.annotations.push(tagResource);
            }
        }
        for (const tagNamed of template.malformedTags) {
            const tagResource = tagAdapter.toResource(tagNamed);
            if (tagResource) {
                templateResource.annotations.push(tagResource);
            }
        }

        return templateResource;
    }

    protected _toModel(resource: ITemplate, model?: Template): Template {
        if (!model) {
            model = Template.MODEL.create<Template>();
        }
        super._toModel(resource, model);
        model.folder = Owned.create<Folder>(Folder.MODEL, model);
        this.context.adapterFor(Folder.MODEL).toModel(resource.folder, model.folder);
        if (resource.annotations) {
            const tagAdapter = this.context.adapterFor(Tag.MODEL);
            for (const tagNamed of resource.annotations) {
                if (typeof tagNamed === 'string') {
                    model.tags.add(tagAdapter.toModel(tagNamed));
                } else {
                    model.malformedTags.add(tagAdapter.toModel(tagNamed));
                }
            }
        }

        return model;
    }
}
